<template>
    <div class="news-form-filter line-filter">
        <ul>
            <li v-for="item in categories" :key="item.id">
                <button type="button" :class="{ active: item.id == currentFilter }" :title="item.title" @click="onChooseCategory(item.id)">
                    {{ item.title }}
                </button>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const emit = defineEmits(['onChangeFilter']);

const { t } = useI18n();
const currentFilter = ref(-1);
const categoriesData = useCategoriesData();

const categories = computed<CmsItem[]>(() => {
    const values: CmsItem[] = [];

    values.push({
        id: -1,
        title: t('news.filter_show_all'),
        slug: null
    });

    if (categoriesData.value?.news.length) {
        categoriesData.value.news.forEach((item: CmsItem) => {
            values.push({
                id: item.id,
                title: item.title,
                slug: item.slug
            });
        });
    }

    return values;
});

const onChooseCategory = (id: number) => {
    currentFilter.value = id;
    emit('onChangeFilter', id);
};
</script>
